import { COMMON_TRANSLATION_KEYS } from "constants/commonTranslationsKeys";
import { ACTION_DETAILS, ACTION_LIST, ACTION_UPDATE } from "models/role/action";
import { SUBJECT_VX2_ONBOARDING, SUBJECT_VX2_PAYMENT } from "models/role/subject";
import { lazyRetry } from "utils/lazyRetry";

import { PAGE_URLS } from "../constants/PageUrls";

import type { Route } from "routes/RouteModel";

const Onboarding = lazyRetry(
  () => import("../pages/Onboarding"),
  "StablecoinsOnboarding"
);

const PaymentsListPage = lazyRetry(
  () => import("../pages/PaymentsList"),
  "StablecoinsPaymentsList"
);

const PaymentPage = lazyRetry(
  () => import("../pages/PaymentPage"),
  "StablecoinsPaymentPage"
);

export const stablecoinsRoutes: Route = {
  path: PAGE_URLS.onboarding,
  title: [COMMON_TRANSLATION_KEYS.stablecoins],
  component: Onboarding,
  can: {
    or: [
      { do: ACTION_UPDATE, on: SUBJECT_VX2_ONBOARDING },
      { do: ACTION_DETAILS, on: SUBJECT_VX2_ONBOARDING },
    ],
  },
};

export const stablecoinsPaymentsRoutes: Route = {
  title: [COMMON_TRANSLATION_KEYS.stablecoins, COMMON_TRANSLATION_KEYS.payments],
  path: PAGE_URLS.payments,
  component: PaymentsListPage,
  showChildrenInSidebar: false,
  can: {
    do: ACTION_LIST,
    on: SUBJECT_VX2_PAYMENT,
  },
  children: [
    {
      path: PAGE_URLS.paymentDetails,
      component: PaymentPage,
      can: {
        do: ACTION_DETAILS,
        on: SUBJECT_VX2_PAYMENT,
      },
      hasNestedSwitch: true,
    },
  ],
};
